var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConnectionLow = function SvgConnectionLow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.225 8.55a.7.7 0 0 1 .7-.7H9.95a.7.7 0 0 1 .7.7v6.15a.7.7 0 0 1-.7.7H7.925a.7.7 0 0 1-.7-.7V8.55Zm.8.1v5.95H9.85V8.65H8.025ZM12.85 4.05a.7.7 0 0 1 .7-.7h2.025a.7.7 0 0 1 .7.7V14.7a.7.7 0 0 1-.7.7H13.55a.7.7 0 0 1-.7-.7V4.05Zm.8.1V14.6h1.825V4.15H13.65Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.325 11.7H2.3a.6.6 0 0 0-.6.6v2.4a.6.6 0 0 0 .6.6h2.025a.6.6 0 0 0 .6-.6v-2.4a.6.6 0 0 0-.6-.6Z",
    fill: "#fff"
  })));
};
export default SvgConnectionLow;